import { render, staticRenderFns } from "./updateGameOrder.vue?vue&type=template&id=3af20878&scoped=true&"
import script from "./updateGameOrder.vue?vue&type=script&lang=js&"
export * from "./updateGameOrder.vue?vue&type=script&lang=js&"
import style0 from "./updateGameOrder.vue?vue&type=style&index=0&id=3af20878&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3af20878",
  null
  
)

export default component.exports